(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iam-curated-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iam-curated-carousel')) {
    customElements.define('iam-curated-carousel', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-iam-rail]');
        this.previous = this.querySelector('[data-iam-prev]');
        this.next = this.querySelector('[data-iam-next]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.update = () => {
          const max = this.rail.scrollWidth - this.rail.clientWidth;
          this.previous.disabled = this.rail.scrollLeft <= 2;
          this.next.disabled = this.rail.scrollLeft >= max - 2;
        };
        const move = direction => {
          const item = this.rail.querySelector('.iam-curated__item');
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          const step = item.getBoundingClientRect().width + gap;
          const max = this.rail.scrollWidth - this.rail.clientWidth;
          const target = Math.max(0, Math.min(max, this.rail.scrollLeft + direction * step));
          this.rail.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
